/// <reference path="../../../../Modules/Attr/Dialog/NoboxEntityDialog.ts" />
namespace Nobox.Nobox {

    @Serenity.Decorators.registerClass()
    @Serenity.Decorators.panel()
    @Serenity.Decorators.maximizable()
    export class LeadExcelDialog extends NoboxEntityDialog<any, any> {
        protected getFormKey() { return LeadExcelForm.formKey; }
        protected form = new LeadExcelForm(this.idPrefix);
        constructor() {
            super();
        }
        dialogOpen() {
            super.dialogOpen();
            $(".s-TemplatedDialog").prepend('<div class="panel-titlebar"><button class="panel-titlebar-close" onClick="$(`.CancelImport`).click()">&nbsp;</button><div class="panel-titlebar-text">Import Excel & CSV</div></div>')
            Q.Router.replace("");
        }
        public callback = (string) => {

        }
        protected updateInterface() {
            super.updateInterface();
        }
        protected setCallback() {
            var $this = this;
            var $form = this.form;
            var hasil = {
                ListId: $this.form.ListId.value,
                Category: $this.form.Category.value,
                Country: $this.form.Country.value
            }
            $this.callback(JSON.stringify(hasil));
        }
        protected getToolbarButtons() {
            var $this = this;
            var btn = super.getToolbarButtons();
            btn[0].cssClass = "ImportBtn";
            //btn[0].visible = false;
            btn[0].onClick = function () {
                if ($this.validateForm()) {
                    $this.setCallback();
                }
            };
            btn[1].title = "Cancel";
            btn[1].hint = "Cancel";
            btn[1].cssClass = "CancelImport";
            btn[1].visible = false;
            btn[1].icon = "fa-times text-red";
            btn[1].onClick = function () {
                $this.dialogClose();
            };
            btn[2].visible = false;
            btn[3].visible = false;
            btn[4].visible = false;
            btn[5].visible = false;
            return btn;
        }
    }
}